/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

/* Custom Functions */
var jsonProduct = null;

function httpGetAsync(theUrl)
{
  return new Promise(function (resolve, reject) {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.onreadystatechange = function() { 
          if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
             resolve(xmlHttp.response);
      }
      xmlHttp.open("GET", theUrl, true); // true for asynchronous 
      xmlHttp.send(null);
  })
}


async function updateSoldOutItems(){
  var jsonProductData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var jsonProductOptions = jsonProductData.options;
  var jsonProductHandle = jsonProductData.handle;

  if(jsonProduct === null){
    try{
      jsonProduct = await httpGetAsync(`${window.Shopify.routes.root}products/${jsonProductHandle}.js`);
      jsonProduct = JSON.parse(jsonProduct);
    }catch(err){
      console.log(err)
    }
  }

  let optionSelectables = document.querySelectorAll('.selector-wrapper');

  function applyDisabled(querySelector, index, isAvail, hasAvail){
    let labelSelector = `.radio__button:nth-child(${index + 1}) input`;

    querySelector.querySelector(labelSelector).classList.toggle("sold-out", false);

    if(!hasAvail && !isAvail){
      querySelector.querySelector(labelSelector).classList.toggle("sold-out", true);
    }

    if(!hasAvail && isAvail){
      querySelector.querySelector(labelSelector).classList.toggle("sold-out", true);
    }

    if(!isAvail){
      querySelector.querySelector(labelSelector).classList.toggle("sold-out", true);
    }
  }

  if(jsonProductOptions && jsonProductOptions[0]){
    var selectOption0 = document.querySelectorAll('.radio__button input:checked')[0].value;
    jsonProduct["options"][0]["values"].forEach((value, valueIndex) => {
      let oneAvailable = jsonProduct['variants'].some((variantData) => variantData['option1'] === value && variantData);
      let hasAvailable = jsonProduct['variants'].some((variantData) => variantData['option1'] === value && variantData["available"]);
      applyDisabled(optionSelectables[0], valueIndex, oneAvailable, hasAvailable);
    });
  }

  if(jsonProductOptions[1]){
    var selectOption1 = document.querySelectorAll('.radio__button input:checked')[1].value;
    jsonProduct["options"][1]["values"].forEach((value2, valueIndex2) => {
      let oneAvailable2option = jsonProduct['variants'].some((variantData) => variantData['option2'] === value2 && variantData['option1'] === selectOption0 && variantData);
      let hasAvailable2option = jsonProduct['variants'].some((variantData) => variantData['option2'] === value2 && variantData['option1'] === selectOption0 && variantData['available']);
      applyDisabled(optionSelectables[1], valueIndex2, oneAvailable2option, hasAvailable2option);
    });
  }

  if(jsonProductOptions[2]){
    var selectOption2 = document.querySelectorAll('.radio__button input:checked')[2].value;
    jsonProduct["options"][2]["values"].forEach((value3, valueIndex3) => {
      let oneAvailable3option = jsonProduct['variants'].some((variantData) => variantData['option3'] === value3 && variantData['option2'] === selectOption1 && variantData['option1'] === selectOption0 && variantData);
      let hasAvailable3option = jsonProduct['variants'].some((variantData) => variantData['option3'] === value3 && variantData['option2'] === selectOption1 && variantData['option1'] === selectOption0 && variantData['available']);
      applyDisabled(optionSelectables[2], valueIndex3, oneAvailable3option, hasAvailable3option);
    });
  }
}


window.addEventListener('load', function () {
    if (window.location.href.includes('products')) {
        updateSoldOutItems();
    }
});


/* End Custom Functions */

if((window.location.href.includes('qk65v2-top-case-pre-order')) || 
    (window.location.href.includes('qk65v2-bottom-case-pre-order')) ||
    (window.location.href.includes('qk65v2-weight-pre-order'))
  ){ window.location.replace('https://www.switchkeys.com.au/products/qk65v2-keyboard-kit-pre-order'); }

if((window.location.href.includes('neo80-top-case-pre-order')) || 
    (window.location.href.includes('neo80-bottom-case-pre-order')) ||
    (window.location.href.includes('neo80-weights-pre-order'))
  ){ window.location.replace('https://www.switchkeys.com.au/products/neo80-keyboard-kit-pre-order'); }

if((window.location.href.includes('qk65v2-classic-bottom-case-pre-order')) || 
    (window.location.href.includes('qk65v2-classic-top-case-pre-order')) ||
    (window.location.href.includes('qk65v2-classic-weight-pre-order'))
  ){ window.location.replace('https://www.switchkeys.com.au/products/qk65v2-classic-keyboard-kit-pre-order'); }

if((window.location.href.includes('neo-ergo-kernel-pre-order')) || 
    (window.location.href.includes('neo-ergo-case-pre-order')) ||
    (window.location.href.includes('neo-ergo-badge-pre-order')) ||
    (window.location.href.includes('neo-ergo-weight-pre-order'))
  ){ window.location.replace('https://www.switchkeys.com.au/products/neo-ergo-keyboard-kit-pre-order'); }

if((window.location.href.includes('tkd-cycle8-case-colour-group-buy')) || 
    (window.location.href.includes('tkd-cycle8-internal-cover-group-buy')) ||
    (window.location.href.includes('tkd-cycle8-weight-group-buy'))
  ){ window.location.replace('https://www.switchkeys.com.au/products/tkd-cycle8-keyboard-kit-group-buy'); }


if(window.location.href.includes('wind-studio-wind-x80-front-accent-piece-weight-block-middle-frame-colour-material-group-buy')){ window.location.replace('https://www.switchkeys.com.au/products/wind-studio-wind-x80-keyboard-kit-group-buy'); }


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    updateSoldOutItems();
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    // var variant = event.detail.variant;
    // var container = event.target;
    // if (variant) {
    //   console.log('Container ———————— ↓');
    //   console.log(container);
    //   console.log('Variant —————————— ↓');
    //   console.log(variant);
    // ... update some element on the page
    // }
  });
  
/* Below is the functions for the theme, this is to keep them commented out so they don't run
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });

  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
*/
})();
